<template>
  <as-dialogo ref="dialogoNovaSenha" title="Nova Senha" max-width="300px" sem-padding>
    <v-container fluid class="pa-2 pb-0">
      <v-col>
        <v-text-field
          label="Senha"
          ref="senha"
          type="password"
          autofocus
          v-model="senha"
          :error-messages="senha.length < 6 ? 'Precisa ter 6 ou mais caracteres': ''"
          @keypress.native.enter="redefinirSenha"
        />
        <v-text-field
          label="Confirmar Senha"
          ref="confirmarSenha"
          type="password"
          v-model="confirmarSenha"
          :error-messages="senha !== confirmarSenha ? 'As senhas devem ser iguais': ''"
          @keypress.native.enter="redefinirSenha"
        />
      </v-col>
      <v-col class="pt-0 pb-5" style="text-align: right">
        <v-btn
          depressed
          color="primary"
          @click="redefinirSenha"
          :disabled="senha !== confirmarSenha || senha.length < 6"
          :loading="loading"
        >Redefinir</v-btn>
      </v-col>
    </v-container>
  </as-dialogo>
</template>

<script>
import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  props: {
    email: { type: String }
  },
  name: "NovaSenha",
  data() {
    return {
      loading: false,
      senha: "",
      confirmarSenha: "",
      msgErro: ""
    };
  },
  methods: {
    abrir() {
      this.$refs.dialogoNovaSenha.abrir();
    },

    fechar() {
      this.$refs.dialogoNovaSenha.fechar();
    },

    async redefinirSenha() {
      this.loading = true;
      try {
        await ServicesUsers.novaSenhaReset(this.email, this.senha);
        this.$eventbus.notificar("Sua senha foi redefinida com sucesso!");
        await ServicesUsers.login({ email: this.email, password: this.senha });
        this.$emit("success", this.senha);
        this.senha = "";
        this.confirmarSenha = "";
        this.$refs.dialogoNovaSenha.fechar();
      } catch (error) {
        if (typeof error.response !== "undefined") {
          this.$eventbus.erro(error.response.data.msg);
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>
